module.exports = __webpack_public_path__ + "img/standardModel-icon-fieldSelector.c5867a51.png";